module.exports = __webpack_public_path__ + "assets/question.6dd93e77.svg";